var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHashtag = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Hashtag",
  fill: "#41505F"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20,7.77017784 L19.4418605,10.7250342 L16.6511628,10.7250342 L16.0930233,13.6798906 L18.8837209,13.6798906 L18.5116279,16.6347469 L15.5348837,16.6347469 L15.1627907,19.4049248 L12.1860465,19.4049248 L12.744186,16.6347469 L9.76744186,16.6347469 L9.20930233,19.4049248 L6.41860465,19.4049248 L6.79069767,16.6347469 L4,16.6347469 L4.55813953,13.6798906 L7.34883721,13.6798906 L7.90697674,10.7250342 L5.11627907,10.7250342 L5.48837209,7.77017784 L8.46511628,7.77017784 L8.8372093,5 L11.8139535,5 L11.255814,7.77017784 L14.2325581,7.77017784 L14.7906977,5 L17.5813953,5 L17.2093023,7.77017784 L20,7.77017784 Z M13.6744186,10.7250342 L10.6976744,10.7250342 L10.1395349,13.6798906 L13.3023256,13.6798906 L13.6744186,10.7250342 Z",
  id: "Shape"
})))));
export { SvgHashtag as ReactComponent };
export default __webpack_public_path__ + "static/media/hashtag.594f6f33.svg";